import { useSelector } from "react-redux";
import { Modal, Button } from "@lynx/ui-components";

import "./payout-modals.scss";

const DisableAutoPayoutModal = ({ onConfirm, onClose }) => {
  const { loading } = useSelector((state) => state.utils);

  return (
    <div className="modal-window">
      <Modal
        className="payout-modal disable-auto-payout-modal cabinet-modals"
        overlayClassName="request-overlay"
        styleType="zimtra-primary"
        isOpen={true}
        hideBlur
        hasCloseIcon={false}
        onClickOutside={onClose}
      >
        <Modal.Header
          className="modal-inner-header"
          onClose={onClose}
          title={<h2 className="zimtra-h2">Disable automatic monthly payout?</h2>}
        />
        <Modal.Body className="modal-inner-body">
          <p className="payout-text">
            Future automatic monthly payouts will stop. Existing payout transactions remain in
            Operations.
          </p>
        </Modal.Body>
        <Modal.Footer className="modal-inner-footer d-flex justify-content-center">
          <Button
            size="md"
            id="auto-payout-disable-confirm-btn"
            buttonStyle="button-variant-second"
            buttonClassName="cabinet-primary-btn"
            disabled={loading}
            onClick={onConfirm}
            label="Disable"
          />
          <Button
            size="md"
            id="auto-payout-keep-btn"
            buttonStyle="button-variant-fourth"
            buttonClassName="cabinet-secondary-btn"
            onClick={onClose}
            label="Keep enabled"
          />
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DisableAutoPayoutModal;
